/**
 * Exact icon assets supplied for the "My Account" stat tiles / premium
 * pill — kept as authored (hardcoded fills/strokes, not currentColor)
 * since these are specific brand icons, not a generic icon-font set.
 * Each accepts a `size` prop controlling width, and scales height to the
 * icon's native aspect ratio; `className`/`styleName` (via react-css-modules)
 * and any other props are forwarded to the root <svg>.
 */
import React from 'react';

export const CouponPointsIcon = ({ size = 34, className, ...rest }) => {
  const width = size;
  const height = (size * 68) / 60;
  return (
    <svg width={width} height={height} viewBox="0 0 60 68" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...rest}>
      <path
        d="M27.375 67.501H7.5C5.42873 67.501 3.75 65.8223 3.75 63.751V34.501H27.375V67.501Z"
        fill="#565656"
      />
      <path
        d="M56.2305 63.751C56.2305 65.8223 54.5517 67.501 52.4805 67.501H32.6055V34.501H56.2305V63.751Z"
        fill="#565656"
      />
      <path
        d="M17.4727 1.73535C19.9769 1.73537 22.268 3.0622 23.4014 5.2373L23.4023 5.23828L28.3711 14.7646H26.3633L25.2861 12.7002L21.8232 6.06152C20.9227 4.33036 19.1802 3.51465 17.4727 3.51465C14.9412 3.51478 12.8897 5.5662 12.8896 8.09766C12.8896 10.0101 14.0736 11.7162 15.8584 12.3896L15.8604 12.3906L23.1377 15.127L25.6396 16.0674V27.5146H3.75C2.63705 27.5146 1.73543 26.6129 1.73535 25.5V20.25C1.73535 19.137 2.637 18.2354 3.75 18.2354H14.4756C16.8775 18.2354 17.484 14.9019 15.2363 14.0557H15.2354C12.754 13.1234 11.1104 10.7496 11.1104 8.09766C11.1104 4.58528 13.9602 1.73535 17.4727 1.73535ZM42.375 1.73535C45.9383 1.73535 48.8896 4.57381 48.8896 8.09766C48.8896 10.75 47.2459 13.1237 44.7646 14.0557H44.7637C42.516 14.9019 43.1225 18.2353 45.5244 18.2354H56.25C57.363 18.2354 58.2646 19.137 58.2646 20.25V25.5C58.2646 26.6129 57.363 27.5146 56.25 27.5146H34.3604V16.0674L36.8623 15.127L44.1396 12.3906L44.1416 12.3896C45.9266 11.7162 47.1104 10.0101 47.1104 8.09766C47.1103 5.32933 44.7923 3.51465 42.375 3.51465C40.6115 3.5147 38.9923 4.49362 38.1768 6.06152L34.7139 12.7002L33.6377 14.7646H31.6289L36.5977 5.23828L36.5986 5.2373C37.7201 3.08451 39.9475 1.73541 42.375 1.73535Z"
        stroke="#565656"
        strokeWidth="3.47021"
      />
    </svg>
  );
};

export const TotalCouponsIcon = ({ size = 34, className, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...rest}>
    <path
      d="M21.978 17.2188L55.2778 50.5186L36.2486 69.5478C32.3128 73.4836 25.9105 73.4836 21.978 69.5478L19.6001 67.1699C18.285 65.8548 18.285 63.7261 19.6001 62.4142C22.224 59.7903 22.224 55.5233 19.6001 52.8996C16.9762 50.2759 12.7092 50.2757 10.0855 52.8996C8.77041 54.2147 6.64168 54.2147 5.32974 52.8996L2.95186 50.5217C-0.983954 46.5859 -0.983954 40.1836 2.95186 36.251L21.978 17.2188Z"
      fill="#565656"
    />
    <path
      d="M37.498 4.19727C40.7423 0.950304 46.0291 0.949091 49.2773 4.19727L51.6553 6.5752L51.6562 6.57715C52.2806 7.20001 52.2832 8.2118 51.6553 8.83984C48.3434 12.1515 48.3438 17.534 51.6553 20.8457C54.9669 24.1574 60.3494 24.1574 63.6611 20.8457L63.6621 20.8438C64.285 20.2194 65.2978 20.2177 65.9258 20.8457L68.3037 23.2236C71.5506 26.4678 71.5517 31.7546 68.3037 35.0029L60.0342 43.2725L29.2246 12.4629L37.4971 4.19824L37.498 4.19727Z"
      stroke="#565656"
      strokeWidth="3.52284"
    />
  </svg>
);

export const MonthlyCouponsIcon = ({ size = 34, className, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...rest}>
    <g opacity="0.56">
      <path
        d="M17.2757 8.6484L33.3513 24.724L21.4992 36.5748C19.5991 38.4748 16.5084 38.4748 14.6099 36.5748L13.462 35.4269C12.8271 34.792 12.8271 33.7643 13.462 33.131C14.7287 31.8643 14.7287 29.8044 13.462 28.5378C12.1953 27.2712 10.1354 27.2711 8.86881 28.5378C8.23395 29.1727 7.2063 29.1727 6.57295 28.5378L5.42502 27.3899C3.52499 25.4898 3.52499 22.3991 5.42502 20.5006L17.2757 8.6484Z"
        fill="#A8A8A8"
      />
      <path
        d="M36.4272 12.463L37.5751 13.6109C39.4752 15.5094 39.4751 18.6 37.5751 20.5001L32.9819 25.0933L16.9062 9.01765L21.501 4.426C23.3995 2.52597 26.4902 2.52597 28.3902 4.426L29.5382 5.57393C30.173 6.20728 30.173 7.23493 29.5382 7.8698C28.2715 9.13641 28.2715 11.1963 29.5382 12.463C30.8048 13.7297 32.8647 13.7297 34.1314 12.463C34.7647 11.8281 35.7924 11.8281 36.4272 12.463Z"
        fill="#A8A8A8"
      />
    </g>
    <path
      d="M11.6855 11.7018L29.887 25.3243L22.1025 35.7256C20.4924 37.8769 17.4331 38.317 15.2834 36.7067L13.9836 35.734C13.2648 35.196 13.1185 34.1788 13.6567 33.4615C14.73 32.0273 14.4367 29.9883 13.0025 28.915C11.5683 27.8417 9.52936 28.135 8.45604 29.5692C7.91806 30.288 6.90087 30.4344 6.18355 29.8962L4.88382 28.9234C2.73253 27.3133 2.29234 24.2541 3.90265 22.1043L11.6855 11.7018Z"
      fill="#565656"
    />
    <path
      d="M18.2054 4.41215C19.5324 2.63756 22.0585 2.27349 23.8339 3.60229L25.1341 4.57449L25.1342 4.57546C25.4753 4.83011 25.5465 5.31383 25.2898 5.65709C23.935 7.46725 24.3052 10.0391 26.1153 11.3939C27.9253 12.7484 30.4964 12.3784 31.8511 10.5686L31.8519 10.5675C32.1067 10.2263 32.5904 10.1559 32.9337 10.4128L34.2339 11.385L34.234 11.386C36.0084 12.7131 36.3717 15.2393 35.0429 17.0147L31.6598 21.5338L14.8212 8.93041L18.2054 4.41215Z"
      fill="white"
      stroke="#565656"
      strokeWidth="1.70069"
    />
  </svg>
);

export const PremiumIcon = ({ size = 18, className, ...rest }) => {
  const width = size;
  const height = (size * 14) / 21;
  return (
    <svg width={width} height={height} viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...rest}>
      <path
        d="M20.1165 4.81392L18.044 13.9034C17.6132 13.788 2.52347 13.7889 2.10438 13.9034L0.0173832 4.81392C-0.042608 4.55486 0.0555592 4.28491 0.267345 4.12493C0.480042 3.96404 0.76636 3.94405 0.999056 4.07221L5.81306 6.69724C5.97758 6.78813 6.17211 6.8054 6.35026 6.74632C6.52842 6.68724 6.67385 6.55544 6.75113 6.38455L9.45621 0.392672C9.56711 0.153625 9.80707 0 10.0707 0C10.3343 0 10.5742 0.153615 10.6851 0.392672L13.3902 6.38455C13.4675 6.55544 13.6129 6.68633 13.7911 6.74541C13.9692 6.8045 14.1638 6.78723 14.3283 6.69724L19.1276 4.07221C19.3612 3.94405 19.6485 3.96405 19.8621 4.12403C20.0748 4.284 20.1746 4.55397 20.1165 4.81392Z"
        fill="white"
      />
    </svg>
  );
};